export default "__VITE_ASSET__DSm3HzaC__"